<template>
  <div class="z_list_vue">
    <div class="z_breadcrumb">
      <div class="z_content">
        <svg-icon className="icon" icon-class="nav_header1" />
        <span>当前位置： </span>
        <span>首页</span>
        <svg-icon className="icon" icon-class="right" />
        <span v-if="type=='2'">{{ className }}</span>
        <span v-else>{{ GetClassName(className) }}</span>
      </div>
    </div>
    <a-spin :spinning="spinning" tip="加载中...">
      <div class="z_detail">
        <div v-if="type == '2'" class="z_sider_nav">
          <ul>
            <li>
              <a
                :class="selectSubNav == '21' ? 'z_selected' : ''"
                @click="subNavClick('21')"
              >
                采购公告
              </a>
            </li>
            <li>
              <a
                :class="selectSubNav == '23' ? 'z_selected' : ''"
                @click="subNavClick('23')"
              >
                变更公告
              </a>
            </li>
            <li>
              <a
                :class="selectSubNav == '22' ? 'z_selected' : ''"
                @click="subNavClick('22')"
              >
                中标候选公示
              </a>
            </li>
            <li>
              <a
                :class="selectSubNav == '20' ? 'z_selected' : ''"
                @click="subNavClick('20')"
              >
                采购文件预公示
              </a>
            </li>
            <li>
              <a
                :class="selectSubNav == '28' ? 'z_selected' : ''"
                @click="subNavClick('28')"
              >
                年度采购预公示
              </a>
            </li>
            <!-- <li>
            <a
              :class="selectSubNav == '29' ? 'z_selected' : ''"
              @click="subNavClick('29')"
            >
              流标公告
            </a>
          </li> -->
          </ul>
        </div>
        <div
          v-if="(type == '0'|| type == '3') && SubCategoryList.length > 0"
          class="z_sider_nav"
        >
          <ul>
            <li v-for="item in SubCategoryList" :key="item.classId">
              <a
                :class="SubCategoryId === item.classId ? 'z_selected' : ''"
                @click="subCategoryClick(item.classId)"
              >
                {{ item.className }}
              </a>
            </li>
          </ul>
        </div>
        <div class="z_content">
          <div class="z_title">
            <!-- 搜索结果页显示⤵️ -->
            <h2 v-if="type === '4'">
              找到关于“{{ keyword }}”，共{{ pagination.total }}个结果
            </h2>
            <!-- 文章页显示⤵️ -->
            <!-- <div v-if="type === '0'">
            <h1>{{ DetailData.title }}</h1>
            <span>发布日期：{{ DetailData.publishDate | moment_d }}</span>
          </div> -->
            <!-- 列表页显示⤵️ -->
            <h2 v-else-if="type=='2'">{{ className }}</h2>
            <h2 v-else>{{ GetClassName(className) }}<span v-show="type == '3'&& cateId == '1202'" style="font-size: 14px;font-weight: bolder;color: rgb(153, 153, 153);float: right;margin-top: 9px;">代理机构考核分数自2023年3月20日起计算</span></h2>
            <!-- 新增标签位置 -->
            <div v-if="type == '2'&&typeshow(selectSubNav)" class="z_sider_nav z_sider_button">
          <ul>
            <li>
              <a
                :class="selectButton == null ? 'z_selected' : ''"
                @click="subNavButtonClick(null)"
              >
                全部
              </a>
            </li>
            <li v-for="buttonitem in ButtonDate" :key="buttonitem.ztbFwptTypeId">
              <a
                :class="selectButton == buttonitem.ztbTypeId ? 'z_selected' : ''"
                @click="isUrl(buttonitem.ztbTypeName)?JumpLink(buttonitem.ztbTypeName):subNavButtonClick(buttonitem.ztbTypeId)"
              >
                {{ buttonitem.ztbTypeName }}
              </a>
            </li>
          </ul>
          <ul>
            <li>
              <a
                :class="selectButton2 == null ? 'z_selected' : ''"
                @click="CGLBButtonClick(null)"
              >
                全部
              </a>
            </li>
            <li v-for="buttonitem in ButtontwoDate" :key="buttonitem.infoTypeId">
              <a
                :class="selectButton2 == buttonitem.infoTypeId ? 'z_selected' : ''"
                @click="CGLBButtonClick(buttonitem.infoTypeId)"
              >
                {{ buttonitem.infoTypeName }}
              </a>
            </li>
          </ul>
        </div>
          </div>
          <div class="z_detail_content">
            <!-- 这理是文章内容 -->
            <!-- <div v-if="type === '0'">
            <p v-html="DetailData.content"></p>
          </div> -->
            <!-- <div v-else-if="type === '1'"> -->
            <div>
              <!-- <a-tabs default-active-key="1" @change="changeList">
                <a-tab-pane key="1" tab="代理机构">
                  
                </a-tab-pane>
                <a-tab-pane key="2" tab="供应商" force-render>
                  
                </a-tab-pane>
              </a-tabs> -->
            </div>
            <div style="display: flex;height: 35px;line-height: 35px;font-size: 16px;font-weight: 100;" v-show="type == '3'&& cateId == '1202'">
              <div :style="listType == '1'?'width:calc(100% - 252px); text-align: left;font-weight: bolder;padding-left: 3%;':'width:calc(100% - 101px); text-align: left;font-weight: bolder;padding-left: 3%;'">{{listType == '1'?'代理机构':'供应商'}}</div>
              <span style="width: 1px;background-color: #bbbbbb;height: 25px;margin-top: 6px;"></span>
              <div v-if="listType == '1'" style="width: 150px;text-align: center;font-weight: bolder;">
                分数 
                <a @click="SSortChange">
                  <svg-icon v-if="scoreSort == ''" style="width: 18px;" className="z_nav_icon" icon-class="sort" />
                  <svg-icon v-if="scoreSort == 'asc'" style="width: 18px;" className="z_nav_icon" icon-class="asc" />
                  <svg-icon v-if="scoreSort == 'desc'" style="width: 18px;" className="z_nav_icon" icon-class="desc" />
                </a>
              </div>
              <span v-if="listType == '1'" style="width: 1px;background-color: #bbbbbb;height: 25px;margin-top: 6px;"></span>
              <div style="width: 100px;text-align: center;font-weight: bolder;">
                宗数
                <a @click="CSortChange">
                  <svg-icon v-if="countSort == ''" style="width: 18px;" className="z_nav_icon" icon-class="sort" />
                  <svg-icon v-if="countSort == 'asc'" style="width: 18px;" className="z_nav_icon" icon-class="asc" />
                  <svg-icon v-if="countSort == 'desc'" style="width: 18px;" className="z_nav_icon" icon-class="desc" />
                </a>
              </div>
            </div>
            <a-list
              v-show="type === '0'||(type == '3'&&cateId != '1202')"
              :pagination="pagination"
              :data-source="data"
              size="small"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">
                    <router-link
                      class="z_list_title_span"
                      :to="'detail?articleId=' + item.articleId"
                      target="_blank"
                      >{{ item.title }}</router-link
                    >
                  </span>
                </a-list-item-meta>
                <div>{{ item.publishDate | moment_d }}</div>
              </a-list-item>
              <!-- <div v-if="loading && !busy" class="demo-loading-container">
                <a-spin />
              </div> -->
            </a-list>
            <a-list
              v-show="type == '1'"
              :pagination="pagination"
              :data-source="data"
              size="small"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                  <span
                        v-show="item.prjNo"
                        :title="item.prjNo"
                        style="width: 150px; margin-right: 8px; height: 24px"
                        class="bulletin_title"
                      >
                        {{ item.prjNo }}
                  </span>
                <a-list-item-meta>
                  <span slot="title">
                    <router-link
                      class="z_list_title_span"
                      :to="(item.ztbTypeId=='0207'||item.ztbTypeId=='0208'||item.ztbTypeId=='0210')?'detail?type=1&prjId=' + item.prjId:'detail?bulletinId=' + item.bulletinId"
                      target="_blank"
                      >
                    {{ item.prjName }}
                     </router-link>
                    </span>
                </a-list-item-meta>
                <div>{{ item.kbDate | moment_d }}</div>
              </a-list-item>
              <!-- <div v-if="loading && !busy" class="demo-loading-container">
                <a-spin />
              </div> -->
            </a-list>
            <a-list
              v-show="type == '2'"
              :pagination="pagination"
              :data-source="data"
              size="small"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">
                    <router-link
                      class="z_list_title_span"
                      :to="'detail?bulletinId=' + item.autoId"
                      target="_blank"
                    >
                      <span
                        v-show="item.infoTypeId"
                        :class="'z-tag ' + item.infoTypeId"
                        >{{
                          item.infoTypeId == "D01"
                            ? "货物"
                            : item.infoTypeId == "D02"||item.infoTypeId == "D05"||item.infoTypeId == "D06"
                            ? "工程"
                            : item.infoTypeId == "D03"
                            ? "服务"
                            : item.infoTypeId == "D07"
                            ? "中介"
                            : "其他"
                        }}
                      </span>
                      <span
                        v-show="item.prjNo"
                        :title="item.prjNo"
                        style="width: 150px; margin-right: 8px; height: 24px"
                        class="bulletin_title"
                      >
                        {{ item.prjNo }}
                      </span>
                      <span
                        :title="item.bulletinTitle"
                        :style="item.prjNo ? 'width: 550px;' : 'width: 700px;'"
                        class="bulletin_title"
                      >
                        {{ item.bulletinTitle }}</span
                      >
                    </router-link>
                  </span>
                </a-list-item-meta>
                <div>{{ item.publishDate | moment_d }}</div>
              </a-list-item>
              <!-- <div v-if="loading && !busy" class="demo-loading-container">
                <a-spin />
              </div> -->
            </a-list>
            <a-list
              v-show="type == '3'&&cateId == '1202'"
              :pagination="pagination"
              :data-source="data"
              size="small"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{ item.customerName }}</span>
                </a-list-item-meta>
                <div v-if="listType=='1'" style="width: 150px;text-align: center;font-weight: bold">
                  <span slot="title">{{ item.grade?item.grade+'分':'/' }}</span>
                </div>
                <div style="width: 100px;text-align: center;font-weight: bold">
                  {{ item.count_project }} <span>宗</span>
                </div>
              </a-list-item>
              <!-- <div v-if="loading && !busy" class="demo-loading-container">
                <a-spin />
              </div> -->
            </a-list>
            <a-list
              v-show="type == '4'"
              :pagination="pagination"
              :data-source="data"
              size="small"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">
                    <router-link
                      class="z_list_title_span"
                      :to="
                        item.type === 1
                          ? 'detail?articleId=' + item.articleId
                          : 'detail?bulletinId=' + item.articleId
                      "
                    >
                      <!-- <span v-if="item.type === 2">【{{ item.className }}】</span> -->
                      {{ item.title }}
                    </router-link>
                  </span>
                </a-list-item-meta>
                <div>{{ item.publishDate | moment_d }}</div>
              </a-list-item>
              <!-- <div v-if="loading && !busy" class="demo-loading-container">
                <a-spin />
              </div> -->
            </a-list>
            <div class="z_detail_content" v-show="type == '4'">
                  <z-card
                    style="margin-top: 16px; min-height: 692px"
                    :titleparam="{
                      iconname: 'nav_header4',
                      iconclass: 'card-title',
                      title: '竞价大厅',
                    }"
                    :btngroup="btngroupbid"
                    @cardbtncallback="biddingCallback"
                    :key="btngroupbid"
                  >
                    <div style="border-top: 1px solid #e8e8e8">
                      <div
                        v-if="
                          biddingType === 0 || biddingType === 1 || biddingType === 2
                        "
                      >
                        <div
                          @click="Bullet(item.prjId)"
                          v-for="item in biddingList"
                          :key="item.prjId"
                          class="bid-card"
                        >
                          <div title="立即报价" class="bid-card-container">
                            <div class="bid-card-head">
                              <div class="bid-card-prjname">{{ item.prjName }}</div>
                              <div class="bid-card-alert" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                                <svg-icon
                                  style="margin-left: 12px"
                                  className="bid-card-svg"
                                  icon-class="jjgs"
                                />
                                {{ item.yzCompanyName }}
                              </div>
                            </div>
                            <div class="bid-card-body">
                              <!-- {{ item.prjContent }} -->
                              <ul>
                                <li>
                                  <div>
                                    <span class="catalogue">品目分类：</span
                                    ><span class="catalogue_span">
                                      {{ item.callingName }}
                                    </span>
                                  </div>
                                </li>
                                <li>
                                  <div>
                                    <span class="catalogue">项目编号：</span
                                    ><span class="catalogue_span">{{
                                      item.prjNo
                                    }}</span>
                                  </div>
                                </li>
                                <li>
                                  <div>
                                    <span class="catalogue">商务要求：</span>
                                    <span class="catalogue_span">{{
                                      item.remark
                                    }}</span>
                                  </div>
                                </li>
                                <li>
                                  <div>
                                    <span class="catalogue">预算价格：</span
                                    ><span class="catalogue_span"
                                      >{{ item.basePrice | NumberFormat }} 元</span
                                    >
                                  </div>
                                </li>
                                <li>
                                  <div>
                                    <span class="catalogue">发布日期：</span
                                    ><span class="catalogue_span"
                                      >{{ item.signUpDate | moment_d }}</span
                                    >
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div class="bid-card-footer">
                              <div
                                v-if="!getcountdown(item.kbDate).showcountdown||item.state==4"
                                style="
                                  text-align: center;
                                  color: #f95965;
                                  font-weight: bold;
                                "
                              >
                                <span>报价结束</span>
                              </div>
                              <div
                                v-else-if="item.state==6"
                                style="
                                  text-align: center;
                                  color: #f95965;
                                  font-weight: bold;
                                "
                              >
                                <span>已暂停</span>
                              </div>
                              <div
                                v-else
                                class="bid-card-footer-countdown"
                              >
                              <span>报价结束倒计时</span>
                                <span class="footer-time" style="margin-left: 8px">{{
                                  getcountdown(item.kbDate).days
                                }}</span>
                                <span>天</span>
                                <span class="footer-time">{{
                                  getcountdown(item.kbDate).hours
                                }}</span>
                                <span>时</span>
                                <span class="footer-time">{{
                                  getcountdown(item.kbDate).minutes
                                }}</span>
                                <span>分</span>
                              </div>
                            </div>
                            <div
                              v-if="item.ztbTypeId === '0208'"
                              :class="
                                item.minFinallyPrice != 0 ? 'bid-card-footer-price' : ''
                              "
                            >
                              <div v-show="item.minFinallyPrice != 0">
                                <div class="price-div">
                                  <span style="margin-left: 8px">¥</span>
                                  <span class="pricespan"
                                    >{{ item.minFinallyPrice | NumberFormat }} 元</span
                                  >
                                </div>

                                <div class="skewX">
                                  <div>当前最低报价</div>
                                </div>
                              </div>
                            </div>
                            <div v-else class="bid-card-footer-btn">
                              <div v-if="!getcountdown(item.kbDate).showcountdown||item.state==4||item.state==6">
                              <button @click="Bullet(item.prjId)">详情</button>
                              </div>
                              <div v-else>
                                <button @click.stop="Offer(item.prjId)">立即报价</button>
                              </div>
                            </div>
                          </div>
                          <img style="position: absolute;top: 155px;right: 10px;" v-if="!getcountdown(item.kbDate).showcountdown||item.state==4" src="../../assets/status3.png" alt="">
                        </div>
                      </div>
                      <div v-else-if="biddingType === 3">
                        <ul class="z-list" style="border-top: 1px solid #e8e8e8">
                          <li v-for="item in biddingResult" :key="item.prjNo">
                            <div class="z-list-title" style="width: auto">
                              <!-- <router-link
                                :to="{
                                  name: 'detail',
                                  query: { bulletinId: item.autoId },
                                }"
                              > -->
                              <span :class="'z-tag ' + getClass(item.ztbTypeId)"
                                >{{ item.ztbTypeName }}
                              </span>

                              <span
                                v-show="item.prjNo"
                                :title="item.prjNo"
                                style="width: 150px; margin-right: 8px"
                                class="z_list_title_span"
                              >
                                <a @click="Bullet2(item.prjId)">{{ item.prjNo }}</a>
                              </span>
                              <a @click="Bullet2(item.prjId)">
                                <!--  :style="item.prjNo ? 'width: 450px' : ''" -->
                              <span
                                :title="item.prjName"
                                class="z_list_title_span"
                              >
                                {{ item.prjName }}
                              </span>
                              </a>
                              <!-- <span :class="'z-tag ' + getClass(item.ztbTypeId)"
                                >{{ item.ztbTypeName }}
                              </span>
                              <span style="width: 480px" class="z_list_title_span">
                                <a @click="Bullet2(item.prjId)">{{ item.prjName }}</a>
                              </span> -->
                              <!-- <span style="width: 300px" class="z_list_title_span">
                                {{ item.zb_customer }}
                              </span> -->
                              <!-- </router-link> -->
                            </div>
                            <div style="float: right; color: #8c8c8c">
                              <!-- <span style="margin-right: 16px">
                                {{ item.finallyPrice | NumberFormat }}
                              </span> -->
                              <span>
                                {{ item.closeDate | moment_d }}
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </z-card>
                  <a-pagination
                    style="text-align: right"
                    v-model="current"
                    :page-size="pageSize"
                    :total="total"
                    @change="PageSizeChange"
                    show-less-items
                  />
            </div>
            <a-list
              v-show="type === '5'"
              :pagination="pagination"
              :data-source="data"
              size="small"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">
                    <router-link
                      class="z_list_title_span"
                      :to="'detail?newsId=' + item.articleId"
                      target="_blank"
                      >{{ item.title }}</router-link
                    >
                  </span>
                </a-list-item-meta>
                <div>{{ item.publishDate | moment_d }}</div>
              </a-list-item>
              <!-- <div v-if="loading && !busy" class="demo-loading-container">
                <a-spin />
              </div> -->
            </a-list>
            <!-- </div> -->
          </div>
          <div v-show="type == '3'&& cateId == '1202'">
            <div style="font-size: 16px;">相关文件</div>
            <div style="display: flex;margin: 24px 0;">
              <img style="width: 26px;height: 26px;margin-top: 8px;" src="../../assets/bullseye.png">
              <div style="margin-left: 25px;color: #262626;line-height: 30px;">
                动态评价分=采购人对采购代理机构计分周期内的所有项目评价的算术平均分X30%+监管部门对采购代理机构计分周期内的所有项目评价的算数平均分x 30%+阳光服务平台对采购代理机构计分周期内的所有项目评价的算术平均分X40%+奖励分-惩戒分
              </div>
            </div>
            <div style="display: flex;">
              <img style="width: 24px;height: 24px;margin-top: 8px;margin-left: 2px;" src="../../assets/img.png">
              <a target="_blank" href="http://ygcg.nbcqjy.org/detail?articleId=277" style="margin-left: 25px;color: #262626;line-height: 50px;">
                宁波市阳光采购服务平台采购代理机构动态评价管理办法 (试行)
              </a>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { GetListByCategoryId, GetSubCategoryList, GetZtbType, GetinfoType} from "@/api/article";
import { GetOpenList, GetIntegrityList, GetOtherList, GetSearchInfo } from "@/api/protal";
import { GetPurchaseResults, GetBiddingHall } from "@/api/Home";
import { GetBulletinList } from "@/api/Home";
import { GetNewsList } from "@/api/Home";
import { mapMutations } from "vuex";
import { GetDeptInfo } from "@/api/Home";
import ZCard from "@/components/card";
import moment from "moment";
export default {
  components: {
    ZCard,
  },
  data() {
    return {
      frequency:0,
      scoreSort:'',
      countSort:'',
      DetailData: {},
      SubCategoryList: [],
      ButtonDate:[],
      ButtontwoDate:[],
      selectSubNav: 0,
      selectButton: null,
      selectButton2: null,
      cateId: 0,
      spinning: true,
      data: [],
      pagination: {
        total: 0,
        pageSize: 15,
        onChange: this.pageChange,
      },
      listParams: {
        pageIndex: 1,
        pageSize: 15,
      },
      SubCategoryId: 0,
      className: this.$route.query.class,
      deptid: this.$route.query.deptId,
      deptid2: this.$route.query.deptid,
      classid: this.$route.query.id,
      listtitle: [
        {
          code:'0',
          title:'平台介绍'
        },
        {
          code:'1',
          title:'平台动态'
        },
        {
          code:'2',
          title:'公告公示'
        },
        {
          code:'3',
          title:'近期开标'
        },
        {
          code:'4',
          title:'政策法规'
        },
        {
          code:'5',
          title:'用户指引'
        },
        // {
        //   code:'5',
        //   title:'常见问题'
        // },
        // {
        //   code:'6',
        //   title:'资料下载'
        // },
        {
          code:'7',
          title:'诚信专栏'
        },
        {
          code:'8',
          title:'新闻动态'
        }
      ],
      listType: '1',
      biddingType: 0,
      btngroupbid: [],
      biddingResult: [],
      current: 1,
      pageSize: 12,
      total: 0,
      biddingList: []
      //   keyword: this.$route.query.keyword,
    };
  },
  computed: {
    type() {
      return this.$route.query.type; //type = 0 文章列表 type = 1 项目列表  type = 2 公告列表 3 诚信专栏列表,4:首页搜索列表,5:新闻列表
    },
    keyword() {
      return this.$route.query.keyword;
    },
    categoryId() {
      return this.$route.query.categoryId;
    },
    noticeType() {
      return this.$route.query.noticeType;
    },
  },
  created() {
    this.btngroupbid = this.GetBtngroupbid()
  },
  mounted() {
    const query = this.$route.query;
    this.deptId = query.deptId; 
    GetZtbType().then((res) =>{
      this.ButtonDate = res.data;
      this.selectSubNav = this.noticeType;
      this.SET_NAV_NAME(this.className);
      this.cateId = this.classid!=null?this.classid:this.categoryId;
      this.GetSubCategory();
    }),
    GetinfoType().then((res) =>{
      this.ButtontwoDate = res.data;
      this.selectSubNav = this.noticeType;
      this.SET_NAV_NAME(this.className);
      this.cateId = this.classid!=null?this.classid:this.categoryId;
      this.GetSubCategory();
    })
  },
  methods: {
    ...mapMutations(["SET_NAV_NAME"]),
    
    PageSizeChange(page) {
      if (this.biddingType != 3) {
        this.pageSize = 12;
      } else {
        this.pageSize = 15;
      }
      this.current = page;
      const query = this.$route.query;
      var deptId = query.deptId;
      this.GetList(deptId);
    },
    getClass(ztbTypeId) {
      if (ztbTypeId === "0208") {
        return "D01";
      } else if (ztbTypeId === "0207") {
        return "D02";
      } else if (ztbTypeId === "0210") {
        return "D03";
      }
    },
    Bullet2(prjId) {
      this.$router.push({
        path: "/detail",
        query: { type: 10, prjId: prjId },
      });
      // window.open("http://ygcg.nbcqjy.org:8059/Bulletin/bulletin.html?prjId="+prjId, "_blank");
    },
    getcountdown(kbDate) {
      //
      var date = moment(kbDate);
      var now = moment();
      let start = moment(new Date()); //获取开始时间
      let end = moment(new Date(kbDate)); //结束时间
      let result = {
        showcountdown: false,
      };
      if (now < date) {
        let diff = end.diff(start); //时间差
        let days = moment.duration(diff).days();
        let hours = moment.duration(diff).hours();
        let minutes = moment.duration(diff).minutes();
        result.days = days > 9 ? days : "0" + days;
        result.hours = hours;
        result.minutes = minutes;
        result.showcountdown = true;
        return result;
      } else {
        return result;
      }
    },
    Bullet(prjId) {
      this.$router.push({
        path: "/detail",
        query: { type: 1, prjId: prjId, biddingType:this.biddingType },
      });
    },
    
    GetList() {
      console.log(123);
      if(this.biddingType != 3){
      let param = {};
        param.pageIndex = this.current;
        param.pageSize = this.pageSize;
        param.classID = "22";
        param.keywords = this.keyword;
        param.deptId = this.deptId;

        if (this.biddingType === 0) {
          param.ztbTypeId = "0000";
        } else if (this.biddingType === 1) {
          param.ztbTypeId = "0208";
        } else if (this.biddingType === 2) {
          param.ztbTypeId = "0210";
        } else if (this.biddingType === 4){
          this.biddingList = [];
        }
        
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total;
          this.biddingList = res.data.projectList;
        });
      }else{
        let _param = {};
        _param.pageIndex = this.current;
        _param.pageSize = this.pageSize;    
        _param.deptId = this.deptId;
        _param.keywords = this.keyword;
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total;
          this.biddingResult = res.data;
        });
      }
    },
    biddingCallback(key, item) {
      if (this.biddingType != 3) {
        this.pageSize = 12;
      } else {
        this.pageSize = 15;
      }
      // this.$router.push({
      //   path: "/biddinglist",
      //   query: { biddingType: item.biddingType , deptId: this.deptId},
      // });
      this.biddingType = item.biddingType;
      this.current = 1;
      if (item.biddingType != 3) {
        let param = {};
        param.pageIndex = this.current;
        param.pageSize = this.pageSize;
        param.classID = "22";
        param.deptId = this.deptId;
        param.keywords = this.keyword;

        if (item.biddingType === 0) {
          param.ztbTypeId = "0000";
        } else if (item.biddingType === 1) {
          param.ztbTypeId = "0208";
        } else if (item.biddingType === 2) {
          param.ztbTypeId = "0210";
        }
        this.biddingList = [];
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total;
          this.biddingList = res.data.projectList;
        });
      } else {
        let _param = {};
        _param.pageIndex = this.current;
        _param.pageSize = this.pageSize;
        _param.deptId = this.deptId;
        _param.keywords = this.keyword;
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total;
          this.biddingResult = res.data;
        });
      }

      // console.log(item.biddingType);
    },
    GetBtngroupbid() {
      var Array = [
        { key: 1, name: "电子询价/竞价/比选", active: true, biddingType: 0 },
        { key: 4, name: "竞价采购结果", active: false, biddingType: 3 },
      ];
      let _biddingType = this.biddingType;
      //let _deptid = Number(this.$route.query.deptid);
      Array.forEach((item) => {
        item.active = false;
        if (item.biddingType === _biddingType) {
          item.active = true;
        }
      });
      return Array;
    },
    SSortChange(){
      this.countSort = ''
      if(this.scoreSort == ''){
        this.scoreSort = 'asc'
      }else if(this.scoreSort == 'asc'){
        this.scoreSort = 'desc'
      }else{
        this.scoreSort = ''
      }
      this.listParams.ssort = this.scoreSort;
      this.listParams.csort = this.countSort;
      GetIntegrityList(this.listParams).then((res) => {
        this.data = res.data.integrityList;
        this.pagination.total = res.data.total;
        this.spinning = false;
      });
    },
    CSortChange(){
      this.scoreSort = ''
      if(this.countSort == ''){
        this.countSort = 'asc'
      }else if(this.countSort == 'asc'){
        this.countSort = 'desc'
      }else{
        this.countSort = ''
      }
      this.listParams.ssort = this.scoreSort;
      this.listParams.csort = this.countSort;
      GetIntegrityList(this.listParams).then((res) => {
        this.data = res.data.integrityList;
        this.pagination.total = res.data.total;
        this.spinning = false;
      });
    },
    changeList(key){
      this.listType = key
      this.listParams.ssort = '';
      this.listParams.csort = '';
      if(key == '1'){
        GetIntegrityList(this.listParams).then((res) => {
          this.data = res.data.integrityList;
          this.pagination.total = res.data.total;
          this.spinning = false;
        });
      }else{
        GetOtherList(this.listParams).then((res) => {
          this.data = res.data.integrityList;
          this.pagination.total = res.data.total;
          this.spinning = false;
        });
      }
    },
    GetClassName (className) {
      for(var i = 0;i<this.listtitle.length;i++){
        if(this.listtitle[i].code == className){
          console.log('传回'+this.listtitle[i].title);
          return this.listtitle[i].title
        }
      }
      return ''
    },
    GetSubCategory() {
      console.log(6);
      
      if (this.type == 0) {
        GetSubCategoryList({ categoryId: this.categoryId }).then((res) => {
          this.SubCategoryList = res.data;
          if (this.SubCategoryList.length > 0) {
            this.SubCategoryId = this.classid!=null?this.classid:this.SubCategoryList[0].classId;
            this.cateId = this.SubCategoryId;
          }
          this.listParams.pageIndex=1;
          this.getListData();
          this.GetList()
        });
      }else if(this.type == 3){
        GetSubCategoryList({ categoryId: 12 }).then((res) => {
          this.SubCategoryList = res.data;
          if (this.SubCategoryList.length > 0) {
            this.SubCategoryId = this.categoryId;
            this.cateId = this.categoryId;
          }
          this.listParams.pageIndex=1;
          this.getListData();
          this.GetList()
        });
      }else {
        this.listParams.pageIndex=1;
        this.getListData();
        this.GetList()
      }
    },
    pageChange(page, pageSize) {
      this.listParams.pageIndex = page;
      this.listParams.pageSize = pageSize;
      if(this.selectSubNav!="20"&&this.selectSubNav!="28"){
      this.listParams.ZtbTypeId = this.selectButton;
      this.listParams.InfoTypeId = this.selectButton2;
      }else{
      this.listParams.ZtbTypeId = null  
      this.listParams.InfoTypeId = null;
      }
      this.getListData();
    },
    GetBulletin(selectSubNav) {
      this.spinning = true;
      this.selectSubNav = selectSubNav;
      if (selectSubNav === "21") {
        this.className = "采购公告";
      } else if (selectSubNav === "23") {
        this.className = "变更公告";
      } else if (selectSubNav === "22") {
        this.className = "中标候选公示";
      } else if (selectSubNav === "20") {
        this.className = "采购文件预公示";
      } else if (selectSubNav === "28"){
        this.className = "年度采购预公示";
      }
      if (this.$route.query.deptName) {
      let param = {};
      param.DeptId = this.deptid2;
      GetDeptInfo(param).then((res) => {
        if(this.frequency ==0){
          if(res.data.deptInfo){
            this.className = res.data.deptInfo.item.deptName + "-" + this.className;
            this.frequency = 1;
          }
        }
      });
      }
      // if (this.$route.query.deptName) {
      //   this.className = this.$route.query.deptName + "-" + this.className;
      // }
      // else if (selectSubNav === "29") {
      //   this.className = "流标公告";
      // }
      this.listParams.DeptId = this.deptid2;
      this.listParams.classID = selectSubNav;
      // this.listParams.deptid = this.deptid;
      if(this.selectSubNav!="20"&&this.selectSubNav!="28"){
      this.listParams.ZtbTypeId = this.selectButton;
      this.listParams.InfoTypeId = this.selectButton2;
      }else{
      this.listParams.ZtbTypeId = null  
      this.listParams.InfoTypeId = null
      }
      console.log(this.listParams);
      GetBulletinList(this.listParams).then((res) => {
        this.data = res.data.bulletinList;
        this.pagination.total = res.data.total;
        this.spinning = false;
      });
    },
    getListData() {
      this.spinning = true;
      this.className = this.$route.query.class;
      this.listParams.categoryId = this.cateId;
      var deptId = this.deptId;
      if(deptId == undefined){
        this.listParams.deptId = "";
        this.deptid = "1001";
      }else{
        this.listParams.deptId = deptId;
        this.deptid = deptId;
      }
      
      if (this.type === "0") {
        //文章列表
        GetListByCategoryId(this.listParams).then((res) => {
          this.data = res.data.articleList;
          this.pagination.total = res.data.total;
          // console.log(res);
          this.spinning = false;
        });
      } else if (this.type === "1") {
        // 今日开标列表
        GetOpenList(this.listParams).then((res) => {
          this.data = res.data.projectList;
          this.pagination.total = res.data.total;
          //this.pagination.total = 4;
          this.spinning = false;
        });
      } else if (this.type === "2") {
        this.GetBulletin(this.noticeType);
        //公告列表
      } else if (this.type === "3") {
        // 诚信专栏列表
        this.listParams.ssort = '';
        this.listParams.csort = '';
        // console.log(this.cateId);
        
        if(this.cateId != '1202'){
          GetListByCategoryId(this.listParams).then((res) => {
            this.data = res.data.articleList;
            this.pagination.total = res.data.total;
            // console.log(res);
            this.spinning = false;
          });
        }else{
          GetIntegrityList(this.listParams).then((res) => {
            this.data = res.data.integrityList;
            this.pagination.total = res.data.total;
            this.spinning = false;
          });
        }
      } else if (this.type === "4") {
        this.listParams.keyword = this.keyword;
        GetSearchInfo(this.listParams).then((res) => {
          this.data = res.data.searchList;
          this.pagination.total = res.data.total;
          this.spinning = false;
        });
      } else if (this.type === "5") {
        console.log(this.deptid,'deptid');
        GetNewsList(this.deptid).then((res) => {
          this.data = res.data.articles;
          this.pagination.total = res.total;
          this.spinning = false;
        });
      }
    },
    subCategoryClick(categoryId) {
      this.cateId = categoryId;
      this.SubCategoryId = categoryId;
      this.getListData();
    },
    subNavClick(classID) {
      this.$router.push({
        path: this.$route.path,
        query: {
          type: 2,
          class: "2",
          noticeType: classID,
          ZtbTypeId: this.selectButton,
          InfoTypeId: this.selectButton2,
          deptName: this.$route.query.deptName,
        },
      });
    },
    JumpLink(name){
      var id = 0;
      switch(name){
        case "电子询价":
          id = 0;
        break;
        case "电子竞价":
          id = 1;
        break;
        case "电子比选":
          id = 2;
        break;
      }
      window.open('/biddinglist?biddingType='+id)
    },
    isUrl(name){
      if(name =="电子询价"||name == "电子竞价"||name == "电子比选"){
        return true;
      }
      return false;
    },
    // 招标类型按钮点击事件
    subNavButtonClick(BclassID){
      this.selectButton = BclassID;
      this.$router.push({
        path: this.$route.path,
        query:{
          type: 2,
          class: "2",
          noticeType: this.selectSubNav,
          ZtbTypeId: BclassID,
          InfoTypeId: this.selectButton2,
          deptName: this.$route.query.deptName,
        },
      })
    },// 采购类别按钮点击事件
    CGLBButtonClick(InfoTypeId){
      this.selectButton2 = InfoTypeId;
      this.$router.push({
        path: this.$route.path,
        query:{
          type: 2,
          class: "公告公示",
          noticeType: this.selectSubNav,
          ZtbTypeId: this.selectButton,
          InfoTypeId: InfoTypeId,
          deptName: this.$route.query.deptName,
        },
      })
    },
    typeshow(typeID){
      if(['21','22','23'].indexOf(typeID)>= 0){
        return true;
      }else{
        return false;
      }
    }
  },
  watch: {
    $route: {
      handler() {
        //this.getListData();
        console.log(111111);
        this.cateId = this.categoryId;
        this.GetSubCategory();

        //深度监听，同时也可监听到param参数变化
      },
    },
  },
};
</script>

<style scoped lang="less">
.bulletin_title {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.z_sider_button>ul>li,.z_sider_button>ul>li>a{
  display: inline-block;
  margin: 0 2px 10px 2px!important;
  height: 32px!important;
  font-size: 14px!important;
  line-height:32px!important;
}
.z_sider_button ul li a{
  padding: 0 16px!important;
}
.z_sider_button{
    width: 100%!important;
}

// .z_list_vue{
//   // 面包屑
//   .z_breadcrumb {
//     width: 1240px;
//     padding: 0 16px;
//     margin: auto;
//     margin-bottom: 16px;
//     .z_content {
//       height: 32px;
//       color: #595959;
//       background: #fafafa;
//       background: linear-gradient(90deg, #fafafa 0%, #fff 100%);
//       padding: 0 16px;
//       span {
//         line-height: 32px;
//         vertical-align: middle;
//       }
//       span:last-child {
//         color: #262626;
//       }
//       .icon {
//         width: 16px;
//         margin-right: 2px;
//         // background: #9005;
//         vertical-align: middle;
//       }
//     }
//   }

//   // 内容布局
//   .z_detail {
//     width: 1240px;
//     min-height: 400px;
//     padding: 0 16px;
//     margin: auto;
//     margin-bottom: 24px;
//     display: flex;
//     justify-content: space-between;
//     // background: #9002;
//     // 侧导航
//     .z_sider_nav {
//       width: 290px;
//       margin-right: 16px;
//       flex-shrink: 0; //不缩小
//       // background: #0092;
//       a {
//         display: block;
//         padding: 0 24px;
//         font-size: 16px;
//         line-height: 48px;
//         border-radius: 2px;
//         margin-bottom: 2px;
//         color: #595959;
//         background: #f5f5f5;
//         // background: #fff1f0;
//       }
//       a:hover {
//         color: #fff;
//         color: #f5222d;
//         background: #ff7875;
//         // background: #ff4d4f;
//         background: #fff1f0;
//       }
//       a:active {
//         color: #fff;
//         background: #f5222d;
//         background: #ff4d4f;
//       }
//       .z_selected {
//         font-weight: 600;
//         color: #fff;
//         background: #ff4d4f;
//         background: linear-gradient(15deg, #ff4d4f 0%, #ff7875 100%);
//       }
//       .z_selected:hover {
//         color: #fff;
//         background: #ff4d4f;
//       }
//     }

//     // 内容区
//     .z_content {
//       width: 100%;
//       color: #262626;
//       //flex-shrink 默认值为1（自动缩放，占满剩余空间）
//       // flex-shrink: 1;
//       // background: #0901;
//       padding: 24px;
//       background: #fbfbfb;
//       border-radius: 2px;
//       .z_title {
//         // background: #9002;
//         border-bottom: 1px solid #e8e8e8;
//         margin-bottom: 24px;
//         h1 {
//           margin-bottom: 8px;
//         }
//         h2 {
//           margin-bottom: 16px;
//         }
//         span {
//           display: inline-block;
//           color: #595959;
//           // background: #f0f0f0;
//           // padding: 4px 12px;
//           margin-bottom: 16px;
//         }
//       }
//     }

//     .z_list_title_span{
//       color: #434343;
//     }
//     .z_list_title_span:hover{
//       color: #f5222d;
//     }
//   }
// }
</style>
